import { Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import OneButton from '../../../../Components/OneButton/OneButton'
import { Dashboard, FormatListBulleted, Search } from '@mui/icons-material'
import { useContext, useState } from 'react'
import { VisitantesContext } from '../../../../Providers/VisitantesContext/VisitantesContext'
import OneInput2 from '../../../../Components/OneInput2/OneInput2'
import { showNotify } from '../../../../Utils/Utils'

const ProcuraMorador = () => {
    const { modoExibicao, mudarExibicao, buscarVisitados } = useContext(VisitantesContext)
    const [textoNome, setTextoNome] = useState('')
    const [textoImovel, setTextoImovel] = useState('')

    const handleChangeInput = (e) => {
        if (e.target.name === 'nome') {
            setTextoNome(e.target.value)
            setTextoImovel('')
        } else {
            setTextoImovel(e.target.value)
            setTextoNome('')
        }
    }

    const handleSubmitNome = (e) => {
        e.preventDefault()
        if (textoNome.length < 3) {
            showNotify('warning', 'Digite pelo menos 3 caracteres para a busca!', 3000)
        } else {
            buscarVisitados(textoNome, 'nome')
        }
    }

    const handleSubmitImovel = (e) => {
        e.preventDefault()
        if (textoImovel.length == 0) {
            showNotify('warning', 'Necessário digitar algo no campo Imóvel para fazer a busca!', 3000)
        } else {
            buscarVisitados(textoImovel, 'imovel')
        }
    }

    return (
        <Grid sx={{
            display: 'flex',
            width: '100%',
            height: '10%',
            borderBottom: '1px solid white',
            alignItems: 'space-around',
            justifyContent: 'space-around'
        }}>
            <Grid component={'form'} onSubmit={handleSubmitNome} xs={6} gap={1} sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-around',
                height: '100%'
            }}>
                <Grid xs={1.3}>
                    <Typography sx={{ color: 'black', fontWeight: '600' }}>Nome:</Typography>
                </Grid>
                <Grid xs={8}>
                    <OneInput2
                        newSx={{ height: '30px' }}
                        value={textoNome}
                        callback={handleChangeInput}
                        name='nome'
                    />
                </Grid>
                <Grid xs>
                    <OneButton
                        id="button"
                        color="one_primary"
                        backgroundColor="#0FBB00"
                        variant="contained"
                        IconStart={Search}
                        type="submit"
                    >
                        Nome
                    </OneButton>
                </Grid>
            </Grid>
            <Grid component={'form'} onSubmit={handleSubmitImovel} xs={3} gap={1} sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-around',
                height: '100%'
            }}>
                <Grid xs={2.5}>
                    <Typography sx={{ color: 'black', fontWeight: '600' }}>Imóvel:</Typography>
                </Grid>
                <Grid xs={7}>
                    <OneInput2
                        newSx={{ height: '30px' }}
                        value={textoImovel}
                        name='imovel'
                        callback={handleChangeInput}
                    />
                </Grid>
                <Grid xs={3}>
                    <OneButton
                        id="button"
                        color="one_primary"
                        backgroundColor="#0FBB00"
                        variant="contained"
                        IconStart={Search}
                        type="submit"
                    >
                        Imovel
                    </OneButton>
                </Grid>
            </Grid>
            <Grid xs={1.5} gap={1} sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-around',
                height: '100%'
            }}>
                <Grid xs={1.5}>
                    <Typography sx={{ color: 'black', fontWeight: '600' }}>Modo:</Typography>
                </Grid>
                <Grid container gap={1.5}>
                    {/* <OneButton
                        id="button"
                        color="one_primary"
                        backgroundColor="#8A05BE"
                        variant="contained"
                        onClick={mudarExibicao}
                    >
                        {modoExibicao == 'card' ? 'Lista' : 'Card'}
                    </OneButton> */}
                    <FormatListBulleted titleAccess='Exibir em lista' sx={{ color: modoExibicao == 'list' ? 'black' : 'grey', cursor: 'pointer' }} onClick={mudarExibicao} />
                    <Dashboard titleAccess='Exibir em cards' sx={{ color: modoExibicao == 'card' ? 'black' : 'grey', cursor: 'pointer' }} onClick={mudarExibicao} />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ProcuraMorador
